export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8664.cbbd6891.jpg";